import React, { useState,useEffect } from 'react';
import { useUser } from '../contexts/UserContext';
import Swal from 'sweetalert2';
import { useAccesos } from '../contexts/AccesosContext';
function AddAreas({onNewArea, editingArea}) {
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [descripcion, setDescripcion] = useState('');
    const [empresa, setEmpresa] = useState('');
    const [empresas, setEmpresas] = useState([]);
    const { user } = useUser();
    const { tienePermiso } = useAccesos();
    const [modificacion, setModificacion] = useState('');
    const [IngresadoPor, setIngresadoPor] = useState('');

    function obtenerFechaISOsinZ() {
        const fecha = new Date();
        let fechaISO = fecha.toISOString(); // "2024-07-30T22:14:46.271Z"
        fechaISO = fechaISO.slice(0, -1); // Elimina la última posición, que es la 'Z'
        return fechaISO;
    }

    // Convertir a una cadena en formato ISO 8601
    const fechaFormateada = obtenerFechaISOsinZ();
    useEffect(() => {
        fetchEmpresas();
        if (editingArea) {
            setDescripcion(editingArea.descripcion);
            setEmpresa(editingArea.idEmpresa);
            setIngresadoPor(editingArea.ingresadoPor);

            setModificacion(2)
        }else{
            setModificacion(1);
            setIngresadoPor('');

        }
    }, [editingArea]);

    const fetchEmpresas = async () => {
        try {
            const response = await fetch(`${server}/MgEmpresas`);
            const data = await response.json();

            setEmpresas(data.$values);
        } catch (error) {
            console.error('Error al cargar las empresas:', error);
        }
    };

    useEffect(() => {
        fetchEmpresas();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const endpoint = editingArea ? `${server}/MgAreas/${editingArea.id}` : `${server}/MgAreas`;
            const method = editingArea ? 'PUT' : 'POST';
            
            const area = {
                id:editingArea ? editingArea.id :0,
                descripcion,
                idEmpresa:empresa,
                IngresadoPor: !editingArea ? (user ? user.codigoUsuario : 'ADMIN               ') : IngresadoPor,
                ModificadoPor: editingArea ? (user ? user.codigoUsuario : 'ADMIN               ') : undefined,
              fechaIngreso: fechaFormateada,
                modificacion
            };
            Object.keys(area).forEach(key => area[key] === undefined && delete area[key]);

            const response = await fetch(endpoint, {
                method: method,
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(area),
            });

            if (response.ok) {
                setDescripcion('');
                setEmpresa('');
                onNewArea();
                Swal.fire({
                    icon: 'success',
                    title: 'Operación exitosa',
                    showConfirmButton: false,
                    timer: 1500
                });
            } else {
                const errorData = await response.json();
                const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                Swal.fire({
                    icon: 'error',
                    title: `Error ${response.status}`,
                    text: errorMessage,
                });            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error al guardar el país',
                text: error || 'Ocurrió un error inesperado',
            });
        }

        // try {
        //     const response = await fetch('https://your-api-endpoint.com/sucursales', {
        //         method: 'POST',
        //         headers: {
        //             'Content-Type': 'application/json',
        //         },
        //         body: JSON.stringify(area),
        //     });

        //     if (response.ok) {
        //         // Limpiar el formulario y manejar la respuesta si es necesario
        //         setDescripcion('');
        //         alert('Area cargada con éxito');
        //         handleNewArea();
        //     } else {
        //         alert('Error al agregar el area');
        //     }
        // } catch (error) {
        //     console.error('Error al agregar el area:', error);
        //     alert('Error al agregar el area');
        // }
    };


    return (
        <>
            <h2>Gestión de Areas</h2>
            <br />
            <form id="Perfiles" data-parsley-validate className="form-horizontal form-label-left" onSubmit={handleSubmit}>
                <div className="item form-group">
                    <label className="col-form-label col-md-3 col-sm-3 label-align" htmlFor="descripcion">
                        Descripcion: <span className="required">*</span>
                    </label>
                    <div className="col-md-2 col-sm-3">
                        <input
                            type="text"
                            id="descripcion"
                            required="required"
                            className="form-control"
                            value={descripcion}
                            onChange={(e) => setDescripcion(e.target.value)}
                        />
                    </div>
                </div>
                <div className="item form-group">
                    <label className="control-label col-md-3 col-sm-3 label-align" htmlFor="Empresa">Empresa</label>
                    <div className="col-md-3 col-sm-6">
                        <select className="form-control" value={empresa} onChange={(e) => setEmpresa(e.target.value)}>
                            <option value="">Elija una opcion</option>
                            {empresas.map((empresa) => (
                                <option key={empresa.idEmpresa} value={empresa.idEmpresa}>{empresa.nombreCompleto}</option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="ln_solid" />
                <div className="item form-group">
                    <div className="col-md-6 col-sm-6 offset-md-3">
                        {/* <button className="btn btn-primary" type="reset">Limpiar</button> */}
                        <button type="submit" className="btn btn-success" disabled={!tienePermiso('Crear Área')}>Guardar</button>
                    </div>
                </div>
            </form>
        </>
    )
}

export default AddAreas